import constants from '../../helpers/constants';
import pricingHelper from '../../helpers/pricingHelper';
import projectsModel from '../../models/projects';
import { prepareField, prepareFieldOptions } from '../../helpers/boardHelpers';

export default {
  groupingFields: (state, getters) => {
    const staticAllowed = ['status', 'priority', 'resources'];
    const customAllowed = ['multiselect', 'select'];

    const staticFields = [];
    const customFields = [];

    const { fieldId: groupingFieldId, isCustomField } = getters.currentConfig?.grouping?.[0] || {};

    getters.allFields.forEach(field => {
      if (!field.isCustom && staticAllowed.includes(field.key)) {
        staticFields.push({
          id: field.id,
          key: field.key,
          isCustom: !!field.isCustom,
          options: field.options,
          value: __(constants.BOARD_FIELD[field.key].locale),
          isGroupedBy: groupingFieldId === field.id && isCustomField == field.isCustom,
          icon: constants.BOARD_FIELD[field.key].icon,
        });
      }

      if (field.isCustom && pricingHelper.checkPricingAccess('custom_fields')) {
        if (customAllowed.includes(field.type)) {
          customFields.push({
            id: field.customFieldId,
            isCustom: !!field.isCustom,
            value: field.name,
            isGroupedBy: groupingFieldId === field.customFieldId && isCustomField == field.isCustom,
            icon: constants.BOARD_FIELD[field.key === 'resources' ? `${field.key}Custom` : field.key].icon,
          });
        }
      }
    });

    staticFields.sort((prev, next) => staticAllowed.indexOf(prev.key) - staticAllowed.indexOf(next.key));

    if (staticFields.length) {
      staticFields.unshift({ type: 'divider', value: __('board_default_fields') });
    }

    if (customFields.length) {
      customFields.unshift({ type: 'divider', value: __('board_custom_fields') });
    }

    return staticFields.concat(customFields);
  },
  sortingFields: (state, getters) => ['status', 'priority', 'name', 'wbs', 'resources', 'createDate', 'startDate', 'endDate']
    .map(fKey => {
      const field = getters.allFields.find(field => field.key === fKey);

      if (!field) {
        return {
          id: 20,
          key: 'createDate',
          name: 'Creation date',
        };
      }

      const { fieldId: sortingFieldId, direction } = getters.currentConfig?.sorting?.values?.[0] || {};

      return {
        id: field.id,
        key: field.key,
        name: __(constants.BOARD_FIELD[field.key].locale),
        icon: constants.BOARD_FIELD[field.key].icon,
        isSortedBy: sortingFieldId === field.id,
        direction,
      };
    }),
  groupingFieldInfo: (state, getters) => {
    const groupingFieldConfig = getters.currentConfig?.grouping?.[0] || {};
    const field = {
      ...getters.allFields.find(field => {
        const fieldId = field.id || field.customFieldId;

        return field.isCustom == groupingFieldConfig.isCustomField && fieldId === groupingFieldConfig.fieldId;
      }),
    } || {};
    const order = groupingFieldConfig.order || [];

    return {
      ...field,
      options: prepareFieldOptions({ field, order }),
    };
  },
  sortingFieldInfo: (state, getters) => {
    const sortingFieldConfig = getters.currentConfig?.sorting?.values?.[0] || {};

    if (!sortingFieldConfig.fieldId) {
      return {};
    }

    return {
      ...getters.allFields.find(field => field.id === sortingFieldConfig.fieldId),
      direction: sortingFieldConfig.direction,
    };
  },
  getField: (state, getters) => function (isCustom, identifier) {
    return getters.allFields.find(field => {
      const fieldIdentifierValue = isCustom ? field.customFieldId : field.key;

      return !!field.isCustom === isCustom && fieldIdentifierValue === identifier;
    });
  },
  currentConfig: (state, getters) => getters.allConfigs[state.projectId] || {},
  customGroupingOptions: (state, getters) => {
    const currentConfig = getters.currentConfig || {};

    if (!currentConfig.customGroupingOptions) {
      return [];
    }

    return currentConfig.customGroupingOptions;
  },
  allFields: (state, getters, rootState, rootGetters) => {
    const allFields = state.allFields.map(field => {
      const projectResources = field.key === 'resources' ? rootGetters['resourcesModel/getResourcesByProjectIdForUI'](state.projectId) : [];
      const isJiraProject = field.key === 'resources' ? projectsModel.getActiveProjectData()?.is_jira : false;

      return prepareField({ field, projectResources, isJiraProject });
    });

    return allFields;
  },
  customSort: (state, getters) => state.customSort,
  customFields: (state, getters) => getters.allFields.filter(field => field.isCustom && ['select', 'multiselect'].includes(field.type)),
  getContextMenu: state => (type, menu) => state.contextMenus.find(item => item.type === type && item.menu === menu),
  projectId: state => state.projectId,
  allConfigs: state => state.allConfigs,
  isLoading: state => state.isLoading,
  contextMenus: state => state.contextMenus,
  nameEditTaskKey: state => state.nameEditTaskKey,
  taskCardEditing: state => state.taskCardEditing,
  taskSettingsInfo: state => state.taskSettingsInfo,
  newTasksPool: state => state.newTasksPool,
  datesWidth: state => state.datesWidth
};
